import { useEffect } from 'react';
import { getToken } from 'firebase/messaging';
import { doc, updateDoc } from 'firebase/firestore';
import { messaging, db } from '../firebase/config';

const VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY;

/**
 * Ber om notistillstånd och sparar FCM-token i users/{uid}.fcmToken.
 * Anropas bara om VAPID_KEY är satt – annars tyst no-op.
 */
export function useFCMToken(uid) {
  useEffect(() => {
    if (!uid || !VAPID_KEY) return;

    let cancelled = false;

    (async () => {
      try {
        const m = await messaging;
        if (!m) return;

        const permission = await Notification.requestPermission();
        if (permission !== 'granted' || cancelled) return;

        const token = await getToken(m, {
          vapidKey: VAPID_KEY,
          serviceWorkerRegistration: await navigator.serviceWorker.register(
            '/firebase-messaging-sw.js'
          ),
        });

        if (token && !cancelled) {
          await updateDoc(doc(db, 'users', uid), { fcmToken: token });
        }
      } catch (err) {
        // Tyst — notiser är ej kritiska
        console.debug('FCM token error:', err);
      }
    })();

    return () => { cancelled = true; };
  }, [uid]);
}
